export const frontmatter = {
    "draft": false,
    "title": "Chatbots",
    "sidebar_group": "reference",
    "sidebar_label": "Chatbots",
    "sidebar_order": 2
}

export const toc = []